import React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';
import { useTranslate } from '@im/react-localization';

const DECIMAL_PLACES = 2;

const PricingMargin = (props: any) => {
  const translate = useTranslate();

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.value.length === 0) props.onChange(null);
    const value = parseFloat(e.target.value);

    if (value >= -100 && value <= 100) {
      const arr = e.target.value.split('.');
      if (arr.length <= 2 && (arr[1]?.length ?? 0) <= DECIMAL_PLACES)
        props.onChange(value);
    }
  }

  return (
    <FormControl
      component={Box}
      data-testid="pricing-margin-delta"
      error={Boolean(props.error)}
      margin={'none'}
    >
      <FormLabel
        htmlFor="delta-cost"
        sx={{
          color: (theme) => theme.palette.text.primary,
          fontSize: '0.875rem',
        }}
      >
        {translate('Pricing.RequestDesiredVLP')}
      </FormLabel>
      <OutlinedInput
        data-testid="outlined-adornment-weight"
        endAdornment={<InputAdornment position="end">%</InputAdornment>}
        id="delta-cost"
        inputMode="numeric"
        inputProps={{ max: 100, min: -100 }}
        name="delta-cost"
        onChange={handleChange}
        style={{
          height: '35px',
          width: '95px',
        }}
        type="number"
        value={props.value ?? ''}
      />
      <FormHelperText sx={{ ml: 0 }}>{props.error}</FormHelperText>
    </FormControl>
  );
};

export default PricingMargin;
